import styled, { css } from 'styled-components/macro'

import { theme, fluidSystem, ChartWrapper, OptionButton, mediaS } from 'styled'

export const Root = styled.div`
  ${fluidSystem};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: ${({ visited }) => (visited ? 'none' : 'all')};
`

export const Donut = styled(ChartWrapper)`
  ${fluidSystem};
  /* flex: 0 999 auto;
  height: 100%;
  width: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 100%;
    height: 100%;
  }

  > .Inner {
    max-height: 450px;
  }
`

export const OptionsRow = styled.div`
  ${fluidSystem};
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
`

export const DonutButton = styled(OptionButton)`
  flex: 1 1 25%;

  &:not(:last-child) {
    margin-right: 8px;

    ${mediaS`
      margin-right: 16px;
    `};
  }
`

const pathModes = {
  outline: css`
    stroke: ${({ highlight }) => theme.colors[highlight ? 'white' : 'mediumGrey']};
  `,
  placeholder: css`
    stroke: ${({ highlight }) => theme.colors[highlight ? 'secondary' : 'white']};
  `,
  selection: css`
    stroke: ${theme.colors.primary};
    opacity: ${({ selected, highlight }) => (selected && !highlight ? 1 : 0)};
  `,
}

export const ArcPath = styled.path.attrs({
  vectorEffect: 'non-scaling-stroke',
})`
  ${({ mode }) => pathModes[mode]};
  stroke-width: ${({ sw }) => sw}px;
  transition: all 0.2s;
`
